import { render, staticRenderFns } from "./SetCommission.vue?vue&type=template&id=4bb672a4&"
import script from "./SetCommission.vue?vue&type=script&lang=js&"
export * from "./SetCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports